const STORAGE_KEY = "ascend-card-sound";
let ctx;

export const isSoundEnabled = () =>
  localStorage.getItem(STORAGE_KEY) !== "off";

export const setSoundEnabled = (on) =>
  localStorage.setItem(STORAGE_KEY, on ? "on" : "off");

const getContext = () => {
  if (!ctx) {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return null;
    ctx = new AC();
    // Ambient session: mixes with music and obeys the iOS silent switch
    if (navigator.audioSession) navigator.audioSession.type = "ambient";
  }
  if (ctx.state === "suspended") ctx.resume().catch(() => {});
  return ctx;
};

// Soft card flick: a filtered noise "swish" plus a tiny low "thup"
export const playFlick = () => {
  if (!isSoundEnabled()) return;
  const ac = getContext();
  if (!ac) return;
  const t = ac.currentTime;

  const master = ac.createGain();
  master.gain.value = 0.22;
  master.connect(ac.destination);

  const len = Math.floor(ac.sampleRate * 0.09);
  const buffer = ac.createBuffer(1, len, ac.sampleRate);
  const data = buffer.getChannelData(0);
  for (let i = 0; i < len; i++) data[i] = (Math.random() * 2 - 1) * (1 - i / len);
  const noise = ac.createBufferSource();
  noise.buffer = buffer;
  const band = ac.createBiquadFilter();
  band.type = "bandpass";
  band.frequency.setValueAtTime(1800, t);
  band.frequency.exponentialRampToValueAtTime(4200, t + 0.08);
  band.Q.value = 0.9;
  const swish = ac.createGain();
  swish.gain.setValueAtTime(0.0001, t);
  swish.gain.exponentialRampToValueAtTime(1, t + 0.012);
  swish.gain.exponentialRampToValueAtTime(0.0001, t + 0.09);
  noise.connect(band).connect(swish).connect(master);
  noise.start(t);
  noise.stop(t + 0.1);

  const thup = ac.createOscillator();
  thup.type = "sine";
  thup.frequency.setValueAtTime(170, t + 0.05);
  thup.frequency.exponentialRampToValueAtTime(70, t + 0.1);
  const thupGain = ac.createGain();
  thupGain.gain.setValueAtTime(0.0001, t + 0.05);
  thupGain.gain.exponentialRampToValueAtTime(0.7, t + 0.058);
  thupGain.gain.exponentialRampToValueAtTime(0.0001, t + 0.11);
  thup.connect(thupGain).connect(master);
  thup.start(t + 0.05);
  thup.stop(t + 0.12);
};
